import React from "react";
import { makeStyles, Typography } from "@material-ui/core";

import CouponForm from "../../../../couponForm";
import { getCartPrice } from "../../../utils";
import TestIcon from "../../../assets/testIcon.svg";
import GuaranteeIcon from "../../../assets/guaranteeIcon.svg";
import { buildWarrantyContent } from "components/product/utils.js";

import CartPrice from "components/product/ProductPrice";

export default function FunnelCartSummary({ cart }) {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        <Typography color="secondary" className={classes.total}>
          Total du panier
        </Typography>
        <CartPrice price={getCartPrice(cart)} />
      </div>
      <div className={classes.divider} />
      <CartReassurance cart={cart} />
      <CouponForm />
    </div>
  );
}

const CartReassurance = ({ cart }) => {
  const classes = useStyle();
  if (cart.selection.length !== 1) {
    return false;
  }
  const label = buildWarrantyContent().label;
  return (
    <>
      <div className={classes.inline}>
        <TestIcon />
        <Typography variant="body2">Sélectionné par nos réparateurs</Typography>
      </div>
      <div className={classes.inline}>
        {console.log(cart.selection[0])}
        <GuaranteeIcon />
        <Typography variant="body2">{label} offerte</Typography>
      </div>
    </>
  );
};

const useStyle = makeStyles((theme) => ({
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  total: {
    fontWeight: 500,
  },
  priceContainer: {
    borderRadius: 50,
    padding: 7,
    paddingRight: 16,
    marginLeft: "auto",
    paddingLeft: 16,
    border: `2px solid ${theme.palette.secondary.main}`,
    boxShadow: `1px 2px ${theme.palette.secondary.main}`,
  },
  tickContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "6px",
    marginLeft: theme.spacing(),
  },
  price: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: "#DBDFE8",
    height: 1,
    width: "100%",
  },
  inline: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    "& > *": {
      marginRight: theme.spacing(2),
    },
  },
}));
